<template>
  <div class="van-tabs-content item5">
    <div
      class="item5-content-box"
      v-for="(item, index) in listData"
      :key="index"
    >
      <img class="type-img" :src="item.typeImg" />
      <div>
        <div class="type-name">{{ item.type }}</div>
        <div class="name-phone">
          <img src="~@/assets/img/ic_user_white.png" />
          <div class="name">{{ item.name }}</div>
          <img src="~@/assets/img/ic_phone_white.png" />
          <div class="name">{{ item.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "infoItem5",
  data() {
    return {
      listData: [
        {
          typeImg: require("@/assets/img/person_type1.png"),
          type: "联络专员",
          name: "李龙飞",
          phone: "13223569521",
        },
        {
          typeImg: require("@/assets/img/person_type2.png"),
          type: "接机",
          name: "刘军",
          phone: "13223569521",
        },
        {
          typeImg: require("@/assets/img/person_type3.png"),
          type: "送机",
          name: "易艾青",
          phone: "13823560124",
        },
        {
          typeImg: require("@/assets/img/person_type4.png"),
          type: "信息采集员",
          name: "路小艾",
          phone: "13823560124",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.van-tabs-content.item5 {
  position: relative;
  margin: 15px 0 0;
  .item5-content-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 80px;
    padding: 15px;
    margin: 0 0 10px;
    background: url("~@/assets/img/Info_item_bg.png") left top no-repeat;
    background-size: contain;
    box-sizing: border-box;
    .type-img {
      display: block;
      margin-right: 15px;
      width: 50px;
      height: 50px;
      object-fit: contain;
    }
    .type-name {
      font-size: 15px;
      font-family: SourceHanSansSC-Bold, SourceHanSansSC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      text-align: left;
    }
    .name-phone {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: start;
      margin: 3px 0 0;
      height: 19px;
      font-size: 13px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      color: #ffffff;
      // line-height: 19px;
      text-align: left;
      img {
        display: block;
        margin-right: 4px;
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
      .name {
        width: 80px;
      }
    }
  }
}
</style>
